export default /*@ngInject*/ function ($rootScope, helperService) {
    return {
        catch: function (response) {
            if (response.data !== "Not authorized for this tenant.") {
                helperService.showErrorMessage(response.data);
            }            
        }
    };
}
